var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentinelBlueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "330 170 600 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3",
    x1: 722.59,
    y1: 245.83,
    x2: 738.19,
    y2: 245.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8309fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e863f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3-2",
    x1: 395.19,
    y1: 251.76,
    x2: 484.93,
    y2: 251.76,
    xlinkHref: "#Gradiente_sem_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3-3",
    x1: 394.86,
    y1: 289.39,
    x2: 484.52,
    y2: 289.39,
    xlinkHref: "#Gradiente_sem_nome_3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M523.39,287.08c4.9,6.9,12.3,9.9,17.8,9.9,7.7,0,10.3-2.8,10.3-5.8,0-3.6-2.7-4.7-12.3-8.4l-8.9-3.4c-10.8-4.1-16.2-9.8-16.2-20.3,0-12.8,11.5-21.5,27.3-21.5,12.5,0,21.6,5.1,28.3,13.1l-12.6,10.7c-6.3-7.3-11.9-9.5-18.4-9.5-4.4,0-7.3,2.1-7.3,5.3s1.5,5.1,8.5,7.5l10.1,3.5c13,4.5,19.2,10.4,19.2,21,0,12.8-10.1,22.5-28.4,22.5-11.3,0-23.2-4.7-30.4-13.3l13-11.3Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.5,297.48c-4.5,9.1-11.7,14.1-22.9,14.1-16.6,0-25.7-10.4-25.7-27.2s9.9-26.5,25.2-26.5c18,0,23.8,13.8,23.8,31.5h-33.5c.8,6.5,4.7,9.3,10.3,9.3,4.3,0,7.6-2,9.2-6l13.6,4.8ZM608.29,278.88c0-5.1-3-9.3-8.6-9.3s-8.8,3.6-9.2,9.3h17.8Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.99,309.88v-27.8c0-3.7-.5-6.2-1.7-7.8-1.1-1.4-2.8-2-5.2-2-3.1,0-5.8,1.7-7.1,3.8-1.5,2.4-2,4.7-2,9.3v24.5h-15.5v-50.4h15.2v7c3.8-4.8,9.4-8,16.4-8,5.5,0,9.5,1.6,12.1,5.1,2.2,3,3.2,7.3,3.2,13.8v32.5h-15.4Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.49,309.68c-3.3.8-6.8,1.2-10.6,1.2-12.8,0-14.7-7.4-14.7-15.6v-23.7h-7v-12.1h7.2v-16.2h15.3v16.2h9.6v12.1h-9.6v21.1c0,4.7,1.5,6,4.6,6,1.3,0,3.8-.3,5.2-.9v11.9Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.59,252.38v-13.1h15.6v13.1h-15.6ZM738.19,309.88h-15.5v-50.4h15.5v50.4Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.29,309.88v-27.8c0-3.7-.5-6.2-1.7-7.8-1.1-1.4-2.8-2-5.2-2-3.1,0-5.8,1.7-7.1,3.8-1.5,2.4-2,4.7-2,9.3v24.5h-15.5v-50.4h15.2v7c3.8-4.8,9.4-8,16.4-8,5.5,0,9.5,1.6,12.1,5.1,2.2,3,3.2,7.3,3.2,13.8v32.5h-15.4Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.09,297.48c-4.5,9.1-11.7,14.1-22.9,14.1-16.6,0-25.7-10.4-25.7-27.2s9.9-26.5,25.2-26.5c18,0,23.8,13.8,23.8,31.5h-33.5c.8,6.5,4.7,9.3,10.3,9.3,4.3,0,7.6-2,9.2-6l13.6,4.8ZM836.89,278.88c0-5.1-3-9.3-8.6-9.3s-8.8,3.6-9.2,9.3h17.8Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.69,309.88h-15.5v-70.6h15.5v70.6Z",
    style: {
      fill: "#0f0146",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 722.59,
    y: 239.28,
    width: 15.6,
    height: 13.1,
    style: {
      fill: "url(#Gradiente_sem_nome_3)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.93,224.45c-4.25,3.96-8.61,7.82-12.73,11.91-12.2,12.1-24.28,24.31-36.45,36.44-12.2,12.17-30.33,9.33-38.3-5.95-4.18-8.02-2.48-18.62,4.52-26.11,5.16-5.52,10.58-10.8,15.99-16.09.84-.82,2.23-1.52,3.37-1.52,20.55-.09,63.34.93,63.6,1.31Z",
    style: {
      fill: "url(#Gradiente_sem_nome_3-2)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.86,317.67c3.21-3.3,5.85-6.08,8.56-8.8,13.65-13.69,27.38-27.31,40.97-41.07,8.61-8.72,21.87-9.59,31.77-1.28,7.68,6.45,11.83,18.6,4.64,29.58-1.92,2.94-4.5,5.48-6.95,8.05-3.88,4.07-7.8,8.1-11.92,11.93-1.14,1.06-2.99,1.89-4.53,1.9-19.91.13-60.97-.08-62.54-.32Z",
    style: {
      fill: "url(#Gradiente_sem_nome_3-3)",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentinelBlueLogo);
export default __webpack_public_path__ + "static/media/sentinel-blue-logo.072de97f773ea1b1abb05c4f576d1a2f.svg";
export { ForwardRef as ReactComponent };